import { render } from "./CustomersViews.vue?vue&type=template&id=1b107352&scoped=true"
import script from "./CustomersViews.vue?vue&type=script&lang=js"
export * from "./CustomersViews.vue?vue&type=script&lang=js"

import "./CustomersViews.vue?vue&type=style&index=0&id=1b107352&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b107352"]])

export default __exports__